import { QAlert } from "./QAlert";
import { sortparams } from "../utils/sortparams";
import { statusTracker } from "../utils/statusTracker";
import { ubtoa } from "../utils/ubtoa";
import { Globals } from "./Globals";
import { QRFCParam } from "./QRFCParam";
import { CRC32 } from "../utils/CRC32";
import { getsessioninfo } from "../utils/getsessioninfo";
import { getsessioncounter } from "../utils/getsessioncounter";
import { uatob } from "../utils/uatob.js";

export class QRFC {
  constructor() {
    this.fRequest = null;
    this.fParams = null;
    this.fCallBackObj = null;
    this.fRequestType = null;
    this.fPostBuffer = null;
    this.fDoChecksum = false;
    this.fEncode = false;

    this.fAllowStacked = null;
    this.fAbort = false;
    this.fRemoteServer = null;
    this.fIsAsync = false;
    this.fRFCMgr = null;

    this.fResolve = null;
    this.fReject = null;

    this.fContentType = "Content-type";
    this.fContentValue = "application/json";
    this.fContentDisp = null;
    this.fDispType = null;
  }

  GetPromise() {
    return new Promise((resolve, reject) => {
      this.fResolve = resolve;
      this.fReject = reject;
    });
  }

  SetAbort() {
    this.fAbort = true;
    this.fReject?.({ isAborted: true, process: this });
  }

  IsAbortedProcess() {
    return this.fAbort === true;
  }

  /**
   * Safely parse JSON response with error handling
   * @param {string} response - The response string to parse
   * @param {function} onError - Optional callback function for handling parse errors
   * @returns {object|null} Parsed JSON object or null if parsing failed
   */
  SafeParseResponse(response, onError) {
    // Handle null, undefined, empty string
    if (!response || response.trim() === "") {
      if (onError) {
        onError({
          code: 666,
          error: new Error("Empty or null response")
        });
      }
      return null;
    }

    try {
      return JSON.parse(response);
    } catch (e) {
      if (onError) {
        onError({
          code: 666,
          error: e
        });
      }
      return null;
    }
  }

  GetCallName() {
    // Override this
  }

  SetPostBuffer(postBuffer) {
    this.fPostBuffer = postBuffer;
  }

  GetRemoteServer() {
    return Globals._accountInfo.GetAPIServer();
  }

  SetRemoteServer(serverAddress) {
    Globals._accountInfo.SetAPIServer(serverAddress);
  }

  SetPostBufferEncoded(postBuffer) {
    this.fPostBuffer = ubtoa(postBuffer); //btoa(postBuffer);
  }

  AddEncodedParameter(parameter, value) {
    //value = encodeURIComponent(value);
    this.AddParameter(parameter, value);
  }

  AddParameter(parameter, value) {
    if (this.fParams == null) this.fParams = [];

    var param = new QRFCParam();
    param.fParameter = parameter;
    param.fValue = value;

    this.fParams.push(param);
  }

  GetParams() {
    if (this.fParams == null) return "";

    this.fParams.sort(sortparams);
    var crcStr = "!";
    var retStr = "";
    var retData = {};
    var n = this.fParams.length;
    for (var i = 0; i < n; i++) {
      var v = this.fParams[i].fValue;
      var p = this.fParams[i].fParameter + "=" + v;
      crcStr += v;
      retStr = retStr + p;
      retData[this.fParams[i].fParameter] = this.fParams[i].fValue;
      if (i != n - 1) {
        retStr = retStr + "&";
      }
    }

    if (this.fDoChecksum) {
      var crc = CRC32.str(crcStr);
      //console.log(crcStr);
      retStr += "&iv=" + crc;
      retData["iv"] = crc;
      this.fcrc = crc;
      if (Globals._sessionKey) {
        retStr += getsessioninfo();
        retData["sk"] = Globals._sessionKey;
        retData["zc"] = getsessioncounter();
      }
    }

    return retData;
  }

  InitRemoteCall(callBackObj, callType, checksum, encode) {
    this.fCallBackObj = callBackObj;
    this.fRequestType = callType;
    this.fAllowStacked = false;
    this.fDoChecksum = checksum;
    this.fDoEncode = encode;
    if (callBackObj) callBackObj.fRFCACtive = true;
    var xmlhttp;
    xmlhttp = new XMLHttpRequest();
    xmlhttp["mgr"] = this;

    //xmlhttp.onprogress = updateprogress;
    xmlhttp.onreadystatechange = statusTracker;

    this.fRequest = xmlhttp;
  }

  AllowStacked() {
    return this.fAllowStacked;
  }

  SetAllowStacked(allowStacked) {
    this.fAllowStacked = allowStacked;
  }

  SetAsync(doAsync) {
    this.fIsAsync = doAsync;
  }

  Send() {
    var xmlhttp = this.fRequest;

    var remoteServer = this.GetRemoteServer();

    if (remoteServer == null) {
      var callPath = "/ServerSide/" + this.GetCallName();
    } else {
      var callPath = remoteServer + "/ServerSide/" + this.GetCallName();
    }

    var params;
    if (this.fParams != null) params = this.GetParams();

    var getReq = true;
    if (this.fRequestType == "GET") callPath = callPath + "?" + params;
    else getReq = false;

    xmlhttp.open(this.fRequestType, callPath, true);

    if (getReq) xmlhttp.send();
    else {
      if (this.fPostBuffer != null) {
        this.fContentValue = "text/plain";
        xmlhttp.setRequestHeader(this.fContentType, this.fContentValue);
        xmlhttp.send(this.fPostBuffer);
      } else {
        xmlhttp.setRequestHeader(this.fContentType, this.fContentValue);
        if (this.fContentDisp != null) {
          xmlhttp.setRequestHeader(this.fContentDisp, this.fDispType);
        }
        xmlhttp.send(JSON.stringify(params));
      }
    }

    if (xmlhttp.onreadystatechange == null) statusTracker();
  }

  SessionEnded(response, callBackObj) {
    Globals._rfcMgr.RFCComplete(this);
    this.DoSessionEnded();
  }

  DoTransactionComplete(response, callBackObj) {
    // Override this
  }

  TransactionComplete() {
    var xmlhttp = this.fRequest;
    var response = xmlhttp.responseText;
    var callBackObj = this.fCallBackObj;
    if (this.fDoEncode) {
      if (response != null) response = uatob(response); // atob(response);
    }
    if (callBackObj) callBackObj.fRFCACtive = false;
    if (!this.IsAbortedProcess()) {
      this.fResolve?.(response);
      this.DoTransactionComplete(response, callBackObj);
    } else {
      console.log("RFC was aborted!", this);
    }
    Globals._rfcMgr.RFCComplete(this);
    //console.log("TransactionComplete");
    //document.getElementById("myDiv").innerHTML=xmlhttp.responseText;
  }

  TransactionFailed() {
    var xmlhttp = this.fRequest;
    var response = xmlhttp.responseText;
    if (!this.IsAbortedProcess()) {
      this.fReject?.(response);
      this.DoTransactionFailed(response, this.fCallBackObj);
    }
    Globals._rfcMgr.RFCComplete(this);
  }

  DoTransactionFailed(response, callBackObj) {
    var rfcMgr = this.fRFCMgr;
    var wsMgr = rfcMgr.fWSMgr;
    var alert = new QAlert();
    console.log("RFC failure");
    alert.InitAlert(
      "Error",
      "There was an unhandled exception processing your request. Please try reloading your browser.",
      wsMgr,
      wsMgr,
      true
    );
    wsMgr.EndProgress();
    wsMgr.PrepRenderWS();
    wsMgr.RenderWS();
  }

  DoSessionEnded(response, callBackObj) {
    var rfcMgr = this.fRFCMgr;
    var wsMgr = rfcMgr.fWSMgr;
    var alert = new QAlert();
    console.log("RFC failure");
    alert.InitAlert(
      "Error",
      "There was an unhandled exception processing your request. Please try reloading your browser.",
      wsMgr,
      wsMgr,
      true
    );
  }
}
